import React from 'react';

export const ConnectPreviewTooltip = () => {
  const [state, setState] = React.useState({ show: false, x: 0, y: 0 });

  React.useEffect(() => {
    const handler = (e) => {
      const { show = false, x = 0, y = 0 } = e.detail || {};
      setState({ show, x, y });
    };
    window.addEventListener('connectPreviewTooltip', handler);
    return () => window.removeEventListener('connectPreviewTooltip', handler);
  }, []);

  if (!state.show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        left: state.x,
        top: state.y,
        transform: 'translate(0, 0)',
        background: 'rgba(0,0,0,0.8)',
        color: '#fff',
        padding: '6px 10px',
        borderRadius: 6,
        fontSize: 12,
        pointerEvents: 'none',
        zIndex: 10000,
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
      }}
    >
      Soltar para conectar
    </div>
  );
};

export default ConnectPreviewTooltip;
